module.exports = __webpack_public_path__ + "static/media/sanid.ef50612c.jpeg";